import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { ButtonLink as ButtonLinkProps } from './types/types';
import { setPrefix } from '../../utils/helpers';
import { defaultLocale } from '../types/constants';

export const StyledButton = styled.a<Partial<ButtonLinkProps>>`
  background-color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButton : props.theme.secondaryButton)};
  color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButtonText : props.theme.secondaryButtonTextColor)};
  height: 35px;
  font-size: 1rem;
  letter-spacing: -0.25px;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
  white-space: nowrap;
  font-weight: 400;
  font-family: ${(props: any) => props.theme.buttonFont} !important;
  overflow: hidden;
  outline: none;
  display: inline-block;
  -webkit-transition: 0.01s;
  transition: 0.01s;
  padding: 0 30px;
  border-radius: 40px;
  border: ${(props: any) => (props.type === 'Primary Button'
    ? `1px solid ${props.theme.primaryButtonBorder}` : `1px solid ${props.theme.secondaryButtonBorder}`)};
  text-decoration: none !important;

&:hover {
  cursor: pointer;
  color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButtonTextHover : props.theme.secondaryButtonTextColorHover)};
  background-color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButtonHover : props.theme.secondaryButtonHover)};
  border: ${(props: any) => (props.type === 'Primary Button'
    ? `1px solid ${props.theme.primaryButtonBorderHover}` : `1px solid ${props.theme.secondaryButtonBorderHover}`)};
  text-decoration: none !important;
}

@media (max-width: 768px) {
  width: fit-content;
  height: 36px;
  font-size: 1rem;
  line-height: 32px;
  padding: 0 16px;
}
`;

export const StyledInternalButton = styled(Link) <Partial<ButtonLinkProps>>`
  background-color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButton : props.theme.secondaryButton)};
  color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButtonText : props.theme.secondaryButtonTextColor)};
  height: 35px;
  font-size: 1rem;
  letter-spacing: -0.25px;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
  white-space: nowrap;
  font-weight: 400;
  font-family: ${(props: any) => props.theme.buttonFont} !important;
  overflow: hidden;
  outline: none;
  display: inline-block;
  -webkit-transition: 0.01s;
  transition: 0.01s;
  padding: 0 30px;
  border-radius: 40px;
  border: ${(props: any) => (props.type === 'Primary Button'
    ? `1px solid ${props.theme.primaryButtonBorder}` : `1px solid ${props.theme.secondaryButtonBorder}`)};
  text-decoration: none !important;

  &:hover {
  cursor: pointer;
  color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButtonTextHover : props.theme.secondaryButtonTextColorHover)};
  background-color: ${(props: any) => (props.type === 'Primary Button'
    ? props.theme.primaryButtonHover : props.theme.secondaryButtonHover)};
  border: ${(props: any) => (props.type === 'Primary Button'
    ? `1px solid ${props.theme.primaryButtonBorderHover}` : `1px solid ${props.theme.secondaryButtonBorderHover}`)};
  text-decoration: none !important;
  }

  @media (max-width: 768px) {
  width: fit-content;
  height: 36px;
  font-size: 1rem;
  line-height: 32px;
  padding: 0 16px;
  }
`;

// passing in props, instead of being more declarative due to my poor field naming of function :)
const ButtonLink = (props: Partial<ButtonLinkProps>) => {
  const {
    node_locale, url, style, displayText,
  } = props;

  const localePrefix = node_locale && node_locale === defaultLocale ? '' : `/${node_locale?.toLowerCase()}`;

  return (
    !url?.startsWith('/')
      ? (
        <StyledButton
          data-testid="buttonAnchor"
          data-component-type="button-styled-link"
          // disabling due to bad naming
          // eslint-disable-next-line react/destructuring-assignment
          href={setPrefix(props.function, url)}
          type={style || 'Primary Button'}
          className="trk-ga button__navigation"
          target="_blank"
          rel="noreferrer"
        >
          {displayText}
        </StyledButton>
      )
      : (
        <StyledInternalButton
          data-testid="buttonLink"
          data-component-type="button-styled-link"
          to={`${localePrefix}${url}`}
          type={style || 'Primary Button'}
          className="trk-ga button__navigation"
          target="_blank"
          rel="noreferrer"
        >
          {displayText}
        </StyledInternalButton>
      )
  );
};

export default ButtonLink;
